export { withCommonPage } from './withCommonPage';
export { withPageEvent } from './withPageEvent';
